/**
 * Sales Rep Orders UI types — backend rows are mapped here by the page adapter.
 */
import { OrderStatus } from '../shared';

export type StatTileColor = 'blue' | 'green' | 'purple' | 'orange';

export interface OrdersStat {
  id: string;
  label: string;
  value: string;
  color: StatTileColor;
  icon: 'orders' | 'value' | 'profit' | 'margin';
}

export interface OrderCard {
  id: string;
  orderId: string;
  customer: string;
  date: string;
  value: string;
  items: string;
  margin: string;
  profit: string;
  status: OrderStatus;
}

/**
 * Maps backend order status (lowercase enum) to the UI status badge label.
 */
export function backendStatusToUi(status: string): OrderStatus {
  switch (status) {
    case 'pending': return 'Submitted';
    case 'confirmed': return 'Approved';
    case 'shipped': return 'In Transit';
    case 'delivered':
    case 'invoiced': return 'Delivered';
    case 'cancelled': return 'Pending';
    default: return 'Draft';
  }
}
